module.exports = __webpack_public_path__ + "img/enter-reservation.f27d3e40.svg";